import { BuilderActionPartial } from "@src/features/libraryItem/contexts/BuilderActionContext";
import { BuilderActionFragment } from "@src/features/libraryItem/hooks/usePollServerForBuilderActions.generated";
import { BuilderActionInput } from "@src/types.generated";
import shouldActionsBeDeduped from "@src/features/libraryItem/module/utils/shouldActionsBeDeduped";
import { useApplyBuilderActionsMutation } from "@src/features/libraryItem/course/build/CourseBuildContent.generated";
import { GraphqlOperations } from "@src/types.generated";
import {
  createBuilderActionsSyncStore,
  useBuilderActionsFlushDriver,
  useSyncMutationHandlers,
} from "@src/features/builders/shared/autosave/builderActionsSync";

// Queue item — BuilderActionPartial carries the payload + the
// client-side fields needed by the dedupe predicate (timestamp) and
// optimistic apply flow (addedModuleContentMembership). The queue
// adds uuid + clientId.
type SyncQueueBuilderAction = BuilderActionPartial &
  Pick<BuilderActionFragment, "uuid" | "clientId">;

export const useSyncBuilderActionsStore =
  createBuilderActionsSyncStore<SyncQueueBuilderAction>(shouldActionsBeDeduped);

const toBuilderActionInput = (
  item: SyncQueueBuilderAction,
): BuilderActionInput => ({
  uuid: item.uuid,
  clientId: item.clientId,
  courseBuilderAction: item.payload.courseBuilderAction,
  moduleBuilderAction: item.payload.moduleBuilderAction,
  skillBuilderAction: item.payload.skillBuilderAction,
  trainingResourceBuilderAction: item.payload.trainingResourceBuilderAction,
});

// Drives the flush lifecycle. Mount once at a level that outlives
// every component that can enqueue (BuilderActionContextProvider).
const useSyncBuilderActionsToServer = (): void => {
  const [applyBuilderActionsMutation, { loading }] =
    useApplyBuilderActionsMutation({
      refetchQueries: [
        GraphqlOperations.Query.SaveModuleDialog,
        GraphqlOperations.Query.CourseVersion,
      ],
      ...useSyncMutationHandlers(useSyncBuilderActionsStore),
    });

  useBuilderActionsFlushDriver({
    store: useSyncBuilderActionsStore,
    mutate: applyBuilderActionsMutation,
    loading,
    transform: toBuilderActionInput,
  });
};

export default useSyncBuilderActionsToServer;
